import "./utilities/sentry.js";
import React from "react";
import { createRoot } from "react-dom/client";
import NavBar from "../jsx/nav";
import Profile from "../jsx/profile";
import "../css/index.css";
import "../css/photo.css";
import axios from "axios";

let user;

document.addEventListener("DOMContentLoaded", async () => {
    await authenticateUser();

    const navContainer = document.getElementById("nav-container");
    if (navContainer) {
        const root = createRoot(navContainer);
        root.render(<NavBar user={user} />);
    }

    const profileContainer = document.getElementById("profile-container");
    if (profileContainer) {
        const root = createRoot(profileContainer);
        root.render(<Profile user={user} />);
    }
    
    checkActivity();
});

const checkActivity = () => {
    let lastActivity = Date.now();
    const updateActivity = () => {
        lastActivity = Date.now();
    };

    document.addEventListener('mousemove', updateActivity);
    document.addEventListener('keydown', updateActivity);
    document.addEventListener('click', updateActivity);
    document.addEventListener('scroll', updateActivity);

    setInterval(async () => {
        const inactiveTime = Date.now() - lastActivity;

        if (inactiveTime < 15 * 60 * 1000) {
            await refreshToken();
        }
    }, 14 * 60 * 1000);
};

const refreshToken = async () => {
    console.log('Refreshing Token...');
    try {
        const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/users/auth/refresh`, {}, { withCredentials: true });
        if (response.status === 200) {
            console.log('Token refreshed successfully');
        } else {
            console.error('Failed to refresh token');
        }
    } catch (error) {
        console.error('Error refreshing token:', error);
    }
};

// Global variable to hold user data
export const authenticateUser = async () => {
    try {
        const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/users/profile`, { withCredentials: true });
        if (response.status === 200) {
            user = response.data;
            return user;
        }
    } catch (error) {
        if (error.response && error.response.status === 401) {
            console.log('User not authenticated. Redirecting to login page.');
            window.location.href = '/login.html';
        } else {
            console.error('Error authenticating user:', error);
        }
    }
};